export default __webpack_public_path__ + "static/media/new-window_gray.29f84101.svg";